import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const deleteVideo = async ({ videoId }: { videoId: string }) =>
  apiClient.delete<unknown, ApiClientResponse<unknown>>(routes.videos.delete(videoId));
